<template>
	<el-dialog title="批量消息提醒" top="1vh" width="600px" :visible.sync="is_show_in_page" @close="close" :modal='false'>
		<el-form  label-width="100px">
			<el-form-item class="el_form_item" label="消息类型">
				<el-select class="el_input" v-model="type" clearable>
					<el-option label="提醒消息" value="1"></el-option>
					<el-option label="功能消息" value="2"></el-option>
				</el-select>
			</el-form-item>
            <el-form-item class="el_form_item" label="功能类别" style="margin-top:20px">
				<el-select class="el_input" v-model="category" clearable>
					<el-option label="非功能" value="1"></el-option>
					<el-option label="操作" value="2"></el-option>
                    <el-option label="数量" value="3"></el-option>
					<el-option label="水印照片" value="4"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item class="el_form_item" label="凭证类别" style="margin-top:20px">
				<el-select class="el_input" v-model="cate" clearable>
					<el-option label="发车" value="1"></el-option>
					<el-option label="到货" value="2"></el-option>
                    <el-option label="其他" value="8"></el-option>
					<el-option label="非功能" value="9"></el-option>
				</el-select>
			</el-form-item>
			<!-- <el-form-item class="el_form_item" label="备注">
				<el-input class="el_inner_width" v-model="category" placeholder="请输入备注" clearable></el-input>
			</el-form-item> -->
			<div style="margin:30px 0 0 0;text-align:center">
				<el-button type="primary" @click="sub">提交</el-button>
			</div>
		</el-form>

	</el-dialog>
</template>
<script>
	export default {
		props:{
            truck_tord_num:String,
			is_show:[Number,Boolean],//是否显示
			list_type:''
		},
		data() {
			return {
				is_show_in_page:false,
				type:'',
                category:'',
				cate:'',
			}
		},
		watch:{
			is_show(new_data){
				if(new_data){
					this.is_show_in_page=true;
				}else{
					this.is_show_in_page=false;
				}
			}
		},
		methods: {
            close(){
             	this.truck_tord_num='',
                this.type='',
                this.category='',
				this.cate=''
            },
			//提交
			sub(){
                this.$my.net.req({
					data:{
						mod:'truck_tord_real_time',
						ctr:'message_add',
						truck_tord_num:this.truck_tord_num,
                        type:this.type,
                        category:this.category,
						cate:this.cate
					},callback:(data)=>{
						this.$my.other.msg({
							str:'操作成功',
							type:'success'
						});
                        this.close()
                        this.is_show_in_page=false;
						if(this.list_type ==1){
							this.$emit('refresh')
						}
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>

	.el_form_item{
		margin: 0;
	}

	.big_tit{
		background-color: #eee;
		padding: 10px 20px;
		color: #666;
		font-weight: 600;
		font-size: 18px;
		margin-top: 20px;
	}

	.tab1_inner{
		padding: 15px 15px 0 15px;
		display: flex;
		align-items: flex-start;
		flex-wrap: wrap;
	}
	
	.el_inner_width{
		width:94%;
	}
	
</style>